import {Component, Input} from '@angular/core';
import {ICON_TYPE} from "@spartacus/storefront";
import {GonvarriOrderPdfAdapter} from "../../core/adapters/gonvarri-order-pdf.adapter";
import {downloadBytes} from "../../utils/download-bytes";

@Component({
    selector: 'app-gonvarri-download-order-pdf',
    templateUrl: './gonvarri-download-order-pdf.component.html',
    styleUrl: './gonvarri-download-order-pdf.component.scss',
    standalone: false
})
export class GonvarriDownloadOrderPdfComponent {

  @Input() orderCode: string | undefined;
  iconTypes = ICON_TYPE;

  constructor(
    private adapter: GonvarriOrderPdfAdapter
  ) {}

  downloadOrderPdf(): void {
    this.adapter.getSingleOrderPdf(
      this.orderCode as string,
      "order",
      0
    ).subscribe((response: any) => downloadBytes(response, `PEDIDO ${this.orderCode}`, "pdf"));
  }

}
